export default __webpack_public_path__ + "static/media/(39)-min.87c32059.jpeg";